import React, { useState, useEffect } from 'react';
import { Dialog } from '@headlessui/react';
import { SwatchIcon } from '@heroicons/react/24/outline';

export default function CustomColorModal({
  isOpen,
  onClose,
  initialColor,
  onColorSelect,
}) {
  const [red, setRed] = useState(255);
  const [green, setGreen] = useState(255);
  const [blue, setBlue] = useState(255);

  useEffect(() => {
    if (initialColor && initialColor.startsWith('#')) {
      // Convert hex to RGB
      const hex = initialColor.replace('#', '');
      setRed(parseInt(hex.substr(0, 2), 16));
      setGreen(parseInt(hex.substr(2, 2), 16));
      setBlue(parseInt(hex.substr(4, 2), 16));
    }
  }, [initialColor]);

  const handleColorChange = () => {
    const hex = `#${red.toString(16).padStart(2, '0')}${green
      .toString(16)
      .padStart(2, '0')}${blue.toString(16).padStart(2, '0')}`;
    onColorSelect(hex.toUpperCase());
    onClose();
  };

  return (
    <Dialog open={isOpen} onClose={onClose} className="relative z-50">
      <div className="fixed inset-0 bg-black/30" aria-hidden="true" />

      <div className="fixed inset-0 flex items-center justify-center p-4">
        <Dialog.Panel className="mx-auto max-w-sm rounded-lg bg-white p-6 shadow-xl">
          <Dialog.Title className="text-lg font-medium mb-4 flex items-center gap-2">
            <SwatchIcon className="h-5 w-5 text-gray-600" />
            Custom Color
          </Dialog.Title>

          <div className="space-y-6">
            {/* Red Channel */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Red ({red})
              </label>
              <input
                type="range"
                min="0"
                max="255"
                value={red}
                onChange={(e) => setRed(parseInt(e.target.value))}
                className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer"
              />
            </div>

            {/* Green Channel */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Green ({green})
              </label>
              <input
                type="range"
                min="0"
                max="255"
                value={green}
                onChange={(e) => setGreen(parseInt(e.target.value))}
                className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer"
              />
            </div>

            {/* Blue Channel */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Blue ({blue})
              </label>
              <input
                type="range"
                min="0"
                max="255"
                value={blue}
                onChange={(e) => setBlue(parseInt(e.target.value))}
                className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer"
              />
            </div>

            {/* Preview */}
            <div className="flex items-center gap-4">
              <div
                className="w-16 h-16 rounded-lg shadow-inner border border-gray-200"
                style={{ backgroundColor: `rgb(${red}, ${green}, ${blue})` }}
              />
              <div className="text-sm text-gray-600">
                HEX: #{red.toString(16).padStart(2, '0')}
                {green.toString(16).padStart(2, '0')}
                {blue.toString(16).padStart(2, '0')}
              </div>
            </div>

            {/* Actions */}
            <div className="flex justify-end gap-3">
              <button
                type="button"
                onClick={onClose}
                className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50"
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={handleColorChange}
                className="px-4 py-2 text-sm font-medium text-white bg-indigo-600 border border-transparent rounded-md hover:bg-indigo-700"
              >
                Apply Color
              </button>
            </div>
          </div>
        </Dialog.Panel>
      </div>
    </Dialog>
  );
}
